<template>
  <div
  class="FilesDashboardRoot scrollbar-container"
  ref="FilesDashboardRootScroll">
    <FilesBar
    v-if="files.length"
    :showRecent="false"
    class="FilesDashboardRoot__bar"/>
    <NoFilesPage v-if="empty"/>
    <transition-group
    tag="div"
    appear
    name="from-right-to-left"
    mode="out-in">
      <FileBar
      v-for="file in files"
      :key="file.id"
      :file='file'/>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import FilesBar from '@/components/files/bar/FilesBar'
import FileBar from '@/components/file/bar/FileBar'

export default {
  name: 'FilesDashboardRoot',

  components: {
    FilesBar,
    FileBar
  },

  computed: {
    ...mapGetters('filesFolder', [
      'folderBusy',
      'folderById'
    ]),
    folder () {
      return this.folderById('root')
    },
    files () {
      return this.folder ? this.folder.files.slice(0).sort((f1, f2) => {
        return f1.name.toLowerCase() > f2.name.toLowerCase() ? 1 : -1
      }) : []
    },
    empty () {
      return !this.files.length && !this.folderBusy
    }
  },

  mounted () {
    this.getUserFiles()
  },

  methods: {
    ...mapActions('filesFolder', [
      'getUserFiles'
    ])
  }
}
</script>

<style lang="scss">
@import 'FilesDashboardRoot';
</style>
